/*
 *
 * Auth constants
 *
 */

export const DEFAULT_ACTION = "app/auth/DEFAULT_ACTION";

export const LOGIN_USER = "app/auth/LOGIN_USER";
export const LOGIN_USER_SUCCESS = "app/auth/LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILED = "app/auth/LOGIN_USER_SUCCESS";

export const LOGOUT_USER = "app/auth/LOGOUT_USER";
export const LOGOUT_USER_FAILED = "app/auth/LOGOUT_USER_FAILED";
export const LOGOUT_USER_SUCCESS = "app/auth/LOGOUT_USER_SUCCESS";

export const CHECK_TOKEN = "app/auth/CHECK_TOKEN";
export const CHECK_TOKEN_SUCCESS = "app/auth/CHECK_TOKEN_SUCCESS";
export const CHECK_TOKEN_FAILED = "app/auth/CHECK_TOKEN_FAILED";

export const HYDRATE_USER = "app/auth/HYDRATE_USER";
export const HYDRATE_SUCCESS = "app/auth/HYDRATE_SUCCESS";
